import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-lg text-background-50 font-bold">17</span>
              </div>
              <span className="text-xl font-bold text-background-50">17吃瓜</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              最新热点娱乐爆料聚合平台。每日更新海量独家内容，带您第一时间围观最劲爆的吃瓜现场。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-sm text-background-50"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                contact@17chigua.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line text-primary-400"></i>
                北京市朝阳区光华路88号
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-primary-400"></i>
                010-8888-6666
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 17吃瓜. All rights reserved.
          </p>
          <p className="text-sm text-foreground-500">
            京ICP备2024000001号-1 | 京公网安备11010102000001号
          </p>
        </div>
      </div>
    </footer>
  );
}